import React from 'react'
import Helmet from 'react-helmet'
import Hero from '../components/ProgramOverview/Hero'
import Apply from '../components/Apply'
import ResourceBlock from '../components/ResourceBlock'
import ResourceQuizBlock from '../components/ResourceQuizBlock'
import Row from '../components/Shared/Row'
import Column from '../components/Shared/Column'

class GapYearResources extends React.Component {
    render() {
        const { data: { pages, quizPages } } = this.props
        //const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``
        // console.log('THE PAGE DATA ===>', page);
        return (
            <div className="page-resources">
                <Helmet title="Gap Year Resources | Global Citizen Year" />
                <Hero title="Gap Year Resources" />
                    <Row className="capper">
                        {
                            pages.edges.map( (edge, index) => {
                                if (edge.node.displayOnResourcesPage) {
                                    return (
                                        <Column width="4" tablet="6" mobile="12" className="author-post resource-padding" key={ index }>
                                            <ResourceBlock data={ edge.node } />
                                        </Column>
                                    )
                                }
                            })
                        }
                        {
                            quizPages.edges.map( (edge, index) => {
                                if (edge.node.showOnResourcesPage) {
                                    console.log(edge.node)
                                    return (
                                        <Column width="4" tablet="6" mobile="12" className="author-post resource-padding" key={ index }>
                                            <ResourceQuizBlock data={ edge.node } />
                                        </Column>
                                    )
                                }
                            })
                        }
                    </Row>
                <Apply
                  title={'Curious about Global Citizen Year? This is a great place to start.'}
                  buttonText="Request Info"
                  buttonUrl="/#signup"
                />
            </div>
        )
    }
}

export default GapYearResources

export const query = graphql`
query resourcesQuery {
   pages: allContentfulDefaultPageTemplate {
      edges {
        node {
          title
          slug
          displayOnResourcesPage
          introText {
              introText
          }
          gapYearResourcesExcerptText
          flexSections {
            bannerImage {
                file {
                    url
                }
            }
          }
        }
      }
    }
    quizPages: allContentfulPageWithIFrame {
    edges {
      node {
        pageTitle
        slug
        quizIntro {
          id
          quizIntro
        }
        showOnResourcesPage
        featuredImage {
          id
          file {
            url
            fileName
            contentType
          }
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/pages/gap-year-resources.js